import { combineReducers } from 'redux';
import { modelReducer } from './modelReducer';
import { forms } from './formReducer';
import { miscellaneousReducer } from './miscellaneousReducer';
import { loadingReducer } from './loadingReducer';
import { loginReducer } from './loginReducer';

const reducer = combineReducers({
    models: modelReducer,
    miscellaneous: miscellaneousReducer,
    loading: loadingReducer,
    login: loginReducer,
    forms
});

export const rootReducer = (state: Object, action: { type: string }) => {
    if (action.type === 'LOGOUT') {
        state = {};
    }
    return reducer(state, action);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts